import React from 'react';
import {
  Users,
  Activity,
  Briefcase,
  Heart,
  Shield,
  Target,
  Zap,
  CheckCircle2,
} from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { mockData } from '../../mock';

const ICON_MAP = {
  Users,
  Activity,
  Briefcase,
  Heart,
  Shield,
  Target,
  Zap,
};

const AudiencesSection = () => {
  const { audiences } = mockData;

  return (
    <section
      id="audiences"
      className="section-padding bg-subtle"
      data-testid="audiences-section"
    >
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Who We Help</h2>
          <p className="section-subtitle">
            Evidence-based programs designed for every stage of life and capability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {audiences.map((audience) => {
            const Icon = ICON_MAP[audience.icon] || Users;
            return (
              <Card
                key={`audience-${audience.id}`}
                className="network-card"
                data-testid={`audience-card-${audience.id}`}
              >
                <CardHeader>
                  <div className="service-icon" aria-hidden="true">
                    <Icon size={28} />
                  </div>
                  <CardTitle className="network-card-title">{audience.title}</CardTitle>
                  <p
                    style={{
                      fontSize: '0.8rem',
                      letterSpacing: '0.15em',
                      textTransform: 'uppercase',
                      color: 'var(--brand-accent, #FFD700)',
                      fontWeight: 600,
                      marginTop: '0.25rem',
                    }}
                  >
                    {audience.ageRange}
                  </p>
                </CardHeader>
                <CardContent>
                  <p className="network-card-content mb-4">{audience.description}</p>
                  <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                    {audience.outcomes.map((outcome) => (
                      <li
                        key={`audience-${audience.id}-${outcome}`}
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '0.5rem',
                          marginBottom: '0.4rem',
                          fontSize: '0.92rem',
                        }}
                      >
                        <CheckCircle2
                          size={16}
                          className="text-brand-primary flex-shrink-0"
                          style={{ marginTop: '3px' }}
                          aria-hidden="true"
                        />
                        <span>{outcome}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AudiencesSection;
